import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import ProfileTabs from "../components/profileComponents/ProfileTabs";
import { ListMyOrders } from "../redux/Actions/OrderActions";
import { getUserDetails } from "../redux/Actions/UserActions";
import Orders from "./../components/profileComponents/Orders";
import { Link } from "react-router-dom";
import EventTabs from "../components/profileComponents/event";
import WithdrawPage from "../components/profileComponents/withdraw";

const ProfileScreen = () => {
  window.scrollTo(0, 0);

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const orderListMy = useSelector((state) => state.orderListMy);
  const { loading, error, orders } = orderListMy;

  useEffect(() => {
    dispatch(ListMyOrders());
    dispatch(getUserDetails("profile"));
  }, [dispatch]);

  const [tab, setTab] = useState(1);

  return (


    <div className="w-full flex justify-center items-center mt-8">
      <div className="w-[--page-width] flex justify-center">
        <div className="grid grid-cols-12 gap-4">
          {/* Sidebar */}
          <div className="col-span-12 md:col-span-3 bg-white shadow rounded-lg overflow-hidden">
            {/* Profile card */}
            <div className="hidden md:block p-6 border-b">
              <div className="flex items-center">
                <div className="w-20 h-20 rounded-full overflow-hidden border">
                  <img src="./images/user.png" alt="userprofileimage" className="w-full h-full object-cover" />
                </div>
                <div className="ml-4">
                  <h5 className="text-lg font-semibold">{userInfo.name}</h5>
                  <span className="text-sm text-gray-500">Đã tham gia {moment(userInfo.createdAt).format("LL")}</span>
                </div>
              </div>
            </div>

            {/* Sidebar menu */}
            <div className="flex flex-col p-4 space-y-2">
              <button
                className={`w-full text-left px-4 py-2 rounded-md ${tab==1?"bg-[--color-button-3] text-white":"bg-[--color-button-1]"} hover:bg-gray-300  font-medium`} onClick={() => setTab(1)}
              >
                Cài đặt hồ sơ
              </button>

              <button
                className={`w-full text-left flex justify-between items-center px-4 py-2 rounded-md  ${tab==2?"bg-[--color-button-3] text-white":"bg-[--color-button-1]"} hover:bg-gray-300 transition`}
                onClick={() => setTab(2)}
              >
                Danh sách đơn hàng
                <span className="text-xs bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full">
                  {orders ? orders.length : 0}
                </span>
              </button>

              <button
                className={`w-full text-left px-4 py-2 rounded-md  ${tab==3?"bg-[--color-button-3] text-white":"bg-[--color-button-1]"} hover:bg-gray-300 transition`}
                onClick={() => setTab(3)}
              >
                Siêu sao kết nối
              </button>

              <button
                className={`w-full text-left px-4 py-2 rounded-md  ${tab==4?"bg-[--color-button-3] text-white":"bg-[--color-button-1]"} hover:bg-gray-300 transition`}
                onClick={() => setTab(4)}
              >
                Đổi thưởng
              </button>
            </div>
          </div>
          <div className="col-span-12 md:hidden p-6 border-b">
              <div className="flex items-center">
                <div className="w-20 h-20 rounded-full overflow-hidden border">
                  <img src="./images/user.png" alt="userprofileimage" className="w-full h-full object-cover" />
                </div>
                <div className="ml-4">
                  <h5 className="text-lg font-semibold">{userInfo.name}</h5>
                  <span className="text-sm text-gray-500">Đã tham gia {moment(userInfo.createdAt).format("LL")}</span>
                </div>
              </div>
            </div>

          {/* Panels */}
          <div className="col-span-12 md:col-span-9 ">
            <div id="profile-settings" className={`${tab == 1 ? "block" : "hidden"}`}>
              <ProfileTabs />
            </div>

            <div id="orders" className={`${tab == 2 ? "block" : "hidden"}`}>
              <Orders orders={orders} loading={loading} error={error} />
            </div>

            <div id="event" className={`${tab == 3 ? "block" : "hidden"}`}>
              <EventTabs />
            </div>

            <div id="withdraw" className={`${tab == 4 ? "block" : "hidden"}`}>
              <WithdrawPage />
            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default ProfileScreen;
